import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '200px',
  },
  adminContainer: {
    padding: theme.spacing(4, 4, 0, 4),
    whiteSpace: 'nowrap',
  },
  labraResaleContainer: {
    padding: theme.spacing(3, 0, 0, 0),
  },
  createOfferBtn: {
    marginLeft: 'auto',
    paddingRight: theme.spacing(3),
  },
  createOfferLink: {
    textDecoration: 'none',
  },
  toolTipView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  verticalDivider: {
    width: '1px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: theme.palette.dividerV2.main,
  },
  dropDownWidth: {
    width: '335px',
  },
  dropdownAndProduct: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '24px',
    marginBottom: theme.spacing(5),
  },
  marginTopSpace: {
    marginTop: theme.spacing(5),
  },
}))
